<script setup lang="ts">
import { onClickOutside } from '@vueuse/core'
import { useCache } from '~/common/useCache'
const app = useAppStore()
const { trackButtonClick } = useAnalytics()

const listVisible = ref(false)
const userMenuRef = ref<HTMLElement>()

// headerFix 상태 가져오기
const { state } = useHeaderFix()
const authStore = useAuthStore()

const toggleListVisible = () => {
  listVisible.value = !listVisible.value
}

const handleOutsideClick = () => {
  listVisible.value = false
}
const logout = () => {
  // 로그아웃 이벤트
  trackButtonClick('logout', '로그아웃', {
    um_idx: app.user.UM_IDX,
    date: new Date().toISOString(),
  })

  // 로그아웃시 쿠키 삭제
  const cookie = useCookie('user')
  cookie.value = undefined

  document.cookie = 'user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'

  // 모든 저장소 초기화
  localStorage.removeItem('auth') // 인증 정보
  localStorage.removeItem('jadoo') // 앱 상태 정보

  sessionStorage.clear()

  //로그아웃시 스토어 데이터 삭제
  app.$dispose()
  authStore.$dispose()

  useRouter().push('/login')

  //200 지연후 이동
  setTimeout(() => {
    location.reload()
  }, 200)
}

const handleBackClick = () => {
  if (state.value.onBackClick) {
    state.value.onBackClick()
  }
}

onClickOutside(userMenuRef, handleOutsideClick)
</script>
<template>
  <header id="header" :class="state.type" v-show="state.isVisible">
    <!-- headerType01 - 기본 유저 메뉴 -->
    <section
      v-if="state.type === 'headerType01'"
      class="userMenu"
      ref="userMenuRef"
    >
      <h3>
        <a :class="listVisible ? 'active' : ''" @click="toggleListVisible">
          <img src="~/assets/images/common/img_user.svg" alt="유저 사진" />
          <span class="name">{{ app.user.UM_NM ?? '사용자' }}님</span>
        </a>
      </h3>
      <ul>
        <li v-if="app.user.UM_FLAG !== '040'">
          <a
            @click="
              () => {
                useRouter().push('/userinfo')
                listVisible = false
              }
            "
          >
            회원정보
          </a>
        </li>
        <li>
          <a
            @click="
              () => {
                useRouter().push('/personalInquiry/inquiry')
                listVisible = false
              }
            "
          >
            1:1 문의
          </a>
        </li>
        <li><a @click="logout">로그아웃</a></li>
      </ul>
    </section>

    <!-- headerType02 - 돌아가기 버튼 -->
    <template v-if="state.type === 'headerType02' && state.showBackButton">
      <a class="btnHeaderBack" @click="handleBackClick">
        {{ state.backButtonText }}
      </a>
      <p class="path">
        <span>유형선택</span>
        <span :class="state.step <= 1 ? `strong` : ''"
          ><template v-if="state.step <= 1">02 </template>지문선택</span
        >
        <span v-if="state.step > 0" :class="state.step > 1 ? `strong` : ''"
          ><template v-if="state.step > 1">03 </template> 변형지문선택</span
        >
      </p>
    </template>
  </header>
</template>
